import {GET_TRANSLATIONS_FAILURE, GET_TRANSLATIONS_START, GET_TRANSLATIONS_SUCCESS, SET_CURRENT_LANGUAGE} from "./actionTypes";
import transformTranslationsResponse from "../helpers/transformTranslationsResponse";

export const getTranslationsStart = () => ({
  type: GET_TRANSLATIONS_START,
  payload: {}
});

export const getTranslationsSuccess = (translationsResponse:any) => ({
  type: GET_TRANSLATIONS_SUCCESS,
  payload: translationsResponse
});

export const getTranslationsFailure = (errors:any) => ({
  type: GET_TRANSLATIONS_FAILURE,
  payload: {errors}
});

export const setCurrentLanguage = (lang:string) => ({
  type: SET_CURRENT_LANGUAGE,
  payload: {lang}
});

const apiUrl = 'https://virtserver.swaggerhub.com/marjan.malovic9/B2BTranslations/0.0.2/';

export function getTranslationsFromApi(dispatch:any, lang: string, translations:any) {
  const url = `${apiUrl}?lang=${lang}`;
  dispatch(getTranslationsStart());
  return fetch(url).then(
    response => response.json()
  ).then(response => {
    const finalData = transformTranslationsResponse(response, translations);
    dispatch(getTranslationsSuccess(finalData))
  }).catch(error => {
    dispatch(getTranslationsFailure(error))
  })
}
